import {Logger} from "./webservice";
import axios from "axios";

async function fetchServerCertificate(
    certificateUrl,
    timeout = 10000,
) {
    try {
        const { data } = await axios.get(certificateUrl, {
            responseType: 'arraybuffer',
            timeout,
        });
        return data;
    } catch (e) {
        Logger.singleton.error('DRM > fetchServerCertificate failed', e);
        return null;
    }
}

export default fetchServerCertificate;
